import { Link } from 'react-router-dom';
import { getFeaturedComics } from '@/mocks/comics';

export default function FeaturedGrid() {
  const featured = getFeaturedComics();

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground-50">
            热门推荐 <span className="text-primary-500" role="img" aria-label="fire">🔥</span>
          </h2>
        </div>

        <div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
          data-product-shop=""
        >
          {featured.map((comic, index) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.slug}`}
              className={`group relative rounded-2xl overflow-hidden border border-background-200/30 transition-all duration-300 hover:border-primary-500/20 ${
                index === 0 ? 'lg:col-span-1' : ''
              }`}
            >
              <div className="aspect-[3/4] relative overflow-hidden">
                <img
                  src={comic.coverImage}
                  alt={`${comic.title} - 韩漫在线阅读`}
                  title={`${comic.title} - ${comic.category}韩漫`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/90 via-background-950/20 to-transparent"></div>

                <div className="absolute top-3 left-3">
                  <span className="text-xs font-medium bg-primary-500/20 text-primary-400 px-2.5 py-1 rounded-full border border-primary-500/10">
                    {comic.status}
                  </span>
                </div>

                <div className="absolute top-3 right-3 flex items-center gap-1 bg-background-950/60 backdrop-blur-sm px-2 py-1 rounded-full">
                  <i className="ri-star-fill text-xs text-accent-500"></i>
                  <span className="text-xs text-foreground-200 font-medium">{comic.rating}</span>
                </div>

                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <p className="text-foreground-50 font-bold text-lg mb-0.5">{comic.title}</p>
                  <p className="text-foreground-400 text-xs mb-2 line-clamp-2">{comic.description}</p>
                  <div className="flex items-center gap-2">
                    <span className="text-xs text-foreground-500">{comic.author}</span>
                    <span className="text-foreground-600">·</span>
                    <span className="text-xs text-foreground-500">{comic.category}</span>
                  </div>
                </div>
              </div>

              <div className="absolute inset-0 bg-primary-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"></div>
            </Link>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/category/romance"
            className="inline-flex items-center gap-2 px-6 py-2.5 text-sm font-medium border border-background-300 text-foreground-300 rounded-full whitespace-nowrap transition-all duration-200 hover:border-primary-500 hover:text-primary-500 cursor-pointer"
          >
            查看全部漫画
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}